export default {
  en: {
    title: 'Custom email templates',
    subtitle: 'List of custom email templates.',
    columns: {
      name: 'Name',
      channels: 'Channels',
      users: 'Team',
    },
    form: {
      infoAlert: {
        message: 'Search information',
        description: 'Can you search by first, last name, username or email, writing in the input.',
      },
      name: {
        error: 'Please fill the name of segment.',
        help: 'This is the name that customers see.',
      },
      channels: {
        error: '',
        help: 'Select where do you want this segment show.',
      },
      baseForm: {
        label: 'Base Form',
        hint: 'This form will be show, when your agents are connected.',
      },
      contactForm: {
        label: 'Contact Form',
        hint: 'This form will be show, when your agents aren\'t connected.',
      },
      surveyForm: {
        label: 'Survey',
        hint: 'Add your custom survey to this segment.',
      },
    },
  },
  es: {
    title: 'Plantillas de emails personalizadas',
    subtitle: 'Listado plantillas de emails personalizadas.',
    columns: {
      name: 'Nombre',
      channels: 'Canales',
      users: 'Equipo',
    },
    form: {
      infoAlert: {
        message: 'Información de búsqueda',
        description: 'Podrás buscar por nombre, apellido, nombre de usuario o email del agente, en la caja de selección.',
      },
      name: {
        error: 'Por favor ingrese el nombre del segmento.',
        help: 'Este el es el nombre que los clientes visualizan.',
      },
      channels: {
        error: '',
        help: 'Seleccione dónde quiere que se muestre este segmento.',
      },
      baseForm: {
        label: 'Formulario base',
        hint: 'Este formulario se mostrará cuando hayan agentes conectados',
      },
      contactForm: {
        label: 'Formulario de contacto',
        hint: 'Este formulario se mostrará cuando no hayan agentes conectados',
      },
      surveyForm: {
        label: 'Encuesta',
        hint: 'Añade una encuesta personalizada.',
      },
    },
  },
  fr: {
    title: 'Modèles d\'email personnalisés',
    subtitle: 'Liste des modèles d\'email personnalisés.',
    columns: {
      name: 'Nom',
      channels: 'Canaux',
      users: 'Équipe',
    },
    form: {
      infoAlert: {
        message: 'Rechercher des informations',
        description: 'Vous pouvez rechercher par prénom, nom, nom d\'utilisateur ou email en écrivant dans le champ.',
      },
      name: {
        error: 'Veuillez remplir le nom du segment.',
        help: 'C\'est le nom que les clients voient.',
      },
      channels: {
        error: '',
        help: 'Sélectionnez où vous souhaitez que ce segment soit affiché.',
      },
      baseForm: {
        label: 'Formulaire de base',
        hint: 'Ce formulaire sera affiché lorsque vos agents sont connectés.',
      },
      contactForm: {
        label: 'Formulaire de contact',
        hint: 'Ce formulaire sera affiché lorsque vos agents ne sont pas connectés.',
      },
      surveyForm: {
        label: 'Sondage',
        hint: 'Ajoutez votre sondage personnalisé à ce segment.',
      },
    },
  }

};
